"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showScriptLoaderBanner = exports.getCompanyDomain = exports.getNextPanelName = exports.hasSettingsUnsavedChanges = exports.isSettingsSubmitting = exports.hasSettingsFetchingError = exports.isSettingsFetching = exports.getTemporalSettings = exports.getSettings = void 0;

var getSettings = function getSettings(state) {
  return state.settings.original;
};

exports.getSettings = getSettings;

var getTemporalSettings = function getTemporalSettings(state) {
  return state.settings.temporal;
};

exports.getTemporalSettings = getTemporalSettings;

var isSettingsFetching = function isSettingsFetching(state) {
  return state.settings.isFetching;
};

exports.isSettingsFetching = isSettingsFetching;

var hasSettingsFetchingError = function hasSettingsFetchingError(state) {
  return state.settings.fetchingHasError;
};

exports.hasSettingsFetchingError = hasSettingsFetchingError;

var isSettingsSubmitting = function isSettingsSubmitting(state) {
  return state.settings.isSubmitting;
};

exports.isSettingsSubmitting = isSettingsSubmitting;

var hasSettingsUnsavedChanges = function hasSettingsUnsavedChanges(state) {
  return state.settings.unsavedChanges;
};

exports.hasSettingsUnsavedChanges = hasSettingsUnsavedChanges;

var getNextPanelName = function getNextPanelName(state) {
  return state.settings.nextPanelName;
};

exports.getNextPanelName = getNextPanelName;

var getCompanyDomain = function getCompanyDomain(state) {
  return getSettings(state).domain;
};

exports.getCompanyDomain = getCompanyDomain;

var showScriptLoaderBanner = function showScriptLoaderBanner(state) {
  var _state$settings = state.settings,
      dismissedScriptLoaderBanner = _state$settings.dismissedScriptLoaderBanner,
      isFetching = _state$settings.isFetching,
      original = _state$settings.original;

  if (dismissedScriptLoaderBanner || isFetching || !original) {
    return false;
  }

  return original.scriptLoaderIsInstalled === false;
};

exports.showScriptLoaderBanner = showScriptLoaderBanner;